import React, { memo } from 'react';
import cc from 'classcat';
/**
 * // TODO: document
 * @constructor
 */
var ControlButton = function (props) {
    var onClick = props.onClick, className = props.className, children = props.children;
    var classList = cc(['date-tab-control', className]);
    return (React.createElement("button", { className: classList, type: "button", onClick: onClick }, children));
};
export default memo(ControlButton);
